import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ModuleService {
  static ENDPOINT = `${BASE}/module`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ModuleService;
